import React, {useState} from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'; import {connect} from 'react-redux';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const QuantitySelector = (props)=>{
    const {handleChange, disable} = props;

    const [total, setTotal] = useState(1);

    const handleValue = (value)=>{
        if (disable) {
            if (value !== 0 && total < 7 ) {
                setTotal(value);
                handleChange(value);
            } else if (total === 7 && value<total) {
                setTotal(value);
                handleChange(value);
            }
        }
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'center',
            alignContent: 'center',
            width: '100px',
            gap: '10px',
            marginRight: '5px',
        }}>
            <div onClick={()=>{
                handleValue(total+1);
            }}
            style={{
                cursor: total === 7 ? 'not-allowed' :'pointer',
                display: 'flex',
            }}>
                <AddCircleIcon sx={{
                    width: '35px',
                    height: '35px',
                    color: total === 7 ? '#828282' :'#FD771A',
                }}/>
            </div>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                {total}
            </div>
            <div onClick={()=>{
                handleValue(total-1);
            }}
            style={{
                cursor: total === 1 ? 'not-allowed' :'pointer',
                display: 'flex',
            }}
            >
                <RemoveCircleIcon
                sx={{
                    width: '35px',
                    height: '35px',
                    color: total === 1 ? '#828282' :'#FD771A',
                }}/>
            </div>
        </div>
    );
};


const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

QuantitySelector.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(QuantitySelector);
